import React from "react";
import WImage from '../images/WhatsappMobile.webp'
import ScanMe from '../../components/images/scan_me.webp';


const WhatsAppCommunity = (props) => {
    const { isSmallScreen } = props;

    return (
        <div
            style={{
                backgroundColor: "#128C7E",
                borderRadius: "20px",
                padding: isSmallScreen ? "20px" : "60px 60px 0px 60px",
                justifyContent: "space-between",
                alignItems: "center",
                color: "white",
                maxWidth: isSmallScreen ? "90%" : "70%",
                margin: "auto",
                fontFamily: "Inter, sans-serif",
            }}>
            <h2
                style={{
                    fontSize: isSmallScreen ? "1.4rem" : "40px",
                    fontWeight: "800",
                    marginBottom: "25px",
                    lineHeight: "1.2",
                    fontFamily: "Poppins, sans-serif",
                }}
            >
                Join Our WhatsApp Community
            </h2>

            <div
                style={{
                    display: "flex"
                }}
            >
                <div style={{ width: isSmallScreen ? "65%" : "35%" }}>
                    <p
                        style={{
                            fontSize: isSmallScreen ? "13px" : "18px",
                            lineHeight: "1.6",
                            color: "#f4f4f4",
                            marginBottom: "20px",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Stay Ahead, Stay Connected
                        <br />
                        Get the latest <b>DevOps & Cloud updates, career tips,</b> and{" "}
                        <b>hands-on tutorials</b> delivered straight to your phone.
                    </p>

                    {!isSmallScreen && <p style={{ fontSize: isSmallScreen ? "15px" : "18px", lineHeight: "1.6", color: "#f4f4f4", fontFamily: "Poppins, sans-serif", }}>
                        Join now, and never miss a chance to grow, learn, and level up!
                    </p>}
                </div>

                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "25px",
                    }}
                >
                    <div style={{ textAlign: "center" }}>
                        <div
                            style={{
                                width: isSmallScreen ? '100%' : "240px",
                                height: isSmallScreen ? '100%' : "240px",
                                borderRadius: "10px",
                                marginBottom: "15px",
                            }}
                            onClick={() => window.open("https://wa.me/918114942378", "_blank")}
                        >
                            <img
                                loading="lazy"
                                src={ScanMe}
                                alt="QR code"
                                style={{ width: "100%", height: "100%", borderRadius: "10px", filter: "invert(1)" }}
                            />
                        </div>
                    </div>

                    {!isSmallScreen && <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                borderRadius: "25px",
                                width: "300px"
                            }}
                        >
                            <img
                                loading="lazy"
                                src={WImage}
                                alt="WhatsApp chat"
                                style={{
                                    width: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </div>
                    </div>}
                </div>
            </div>
            {isSmallScreen && <p style={{ fontSize: isSmallScreen ? "13px" : "18px", lineHeight: "1.6", color: "#f4f4f4", fontFamily: "Poppins, sans-serif", }}>
                Join now, and never miss a chance to grow, learn, and level up!
            </p>}
        </div>
    );
};

export default WhatsAppCommunity;
